import { KoffieDienst } from "@/entities/dossier-overzicht";
import { VestigingStatus } from "@/entities/vestiging";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { KoffieStatus } from "./icons/koffie-status";

type KoffieStatusEnTooltipProps = {
    dienst: KoffieDienst;
};

export function KoffieStatusEnTooltip({ dienst }: KoffieStatusEnTooltipProps) {
    const labels = [
        { label: "in behandeling", count: dienst.countByStatus?.Besteld },
        { label: "actief", count: dienst.countByStatus?.Actief },
        { label: "gaat niet leveren", count: dienst.countByStatus?.GaatNietLeveren },
        { label: "stop aangevraagd", count: dienst.countByStatus?.StopAangevraagd },
        { label: "gestopt", count: dienst.countByStatus?.Gestopt },
    ];

    return (
        <Tooltip key={dienst.type}>
            <TooltipTrigger data-testid="koffie-status">
                <KoffieStatus variant={dienst.variant} />
            </TooltipTrigger>
            <TooltipContent className="max-w-full">
                {dienst.landelijkeFaciliteiten && landelijkeFaciliteitenStatusLabelMap[dienst.landelijkeFaciliteiten]}
                {labels
                    .filter(({ count }) => count && count > 0)
                    .map(({ label, count }) => (
                        <p key={label}>
                            {count} vestiging{count === 1 ? "" : "en"} {label}
                        </p>
                    ))}
            </TooltipContent>
        </Tooltip>
    );
}

const landelijkeFaciliteitenStatusLabelMap = {
    Besteld: "Landelijke faciliteiten in behandeling",
    Actief: "Landelijke faciliteiten actief",
    StopAangevraagd: "Stop landelijke faciliteiten aangevraagd",
    Gestopt: "Landelijke faciliteiten gestopt",
    GaatNietLeveren: "Landelijke faciliteiten gaan niet leveren",
} satisfies Record<VestigingStatus, string>;
